module.exports = __webpack_public_path__ + "static/media/ADD TO FAV_WHITE.36dc10b3.svg";